<div (click)="showMe = !showMe" class="d-flex flex-grow justify-content-between no-select cursor-pointer">
  <h3 class="zero-text p-base-med">{{ 'user-self-service.krypto-wallet.headline' | transloco }}</h3>
  <web-design-system-icon name="chevron" [class.icon-rotate]="!showMe" />
</div>

<div class="p-3" [class.d-none]="!showMe">
  <self-service-crypto-wallet />
</div>
